import { React, Link } from '../../libraries'

import { TitleSection } from '../atom'
import { FaDoorOpen } from '../icons'
import { HandleError } from '../atom'

const DateFormat = ({dateTime, status}) => {
    let dateFormatValue = new Intl.DateTimeFormat("en-GB", {
        year: "numeric",
        day: "2-digit",
        month: "long"
    }).format(new Date(dateTime))

    dateFormatValue = dateFormatValue.split(' ')

    if(status === 1)
        return dateFormatValue[0] + " " + dateFormatValue[2]
    else
        return dateFormatValue[1] + " " + dateFormatValue[0]
}

const DateFormat2 = ({dateTime, status}) => {
    let dateFormatValue = new Intl.DateTimeFormat("en-GB", {
        weekday: "long",
        year: "numeric",
        day: "2-digit",
        month: "long"
    }).format(new Date(dateTime))

    dateFormatValue = dateFormatValue.split(' ')

    return dateFormatValue[0] + " " + dateFormatValue[2] + " " + dateFormatValue[1] + " " + dateFormatValue[3] 
}

export const ThumbnailHistory = (props) => {
    const { Type, allData } = props

    console.log("allData", allData)

    return(
        <div className={`w-full ${!Type && "shadow"} py-3 lg:px-4 px-0 mb-6 rounded-md flex flex-wrap`}>
            <div className={`xl:w-1/4 sm:w-4/12 w-full sm:pr-6 pr-0 ${Type && "hidden"}`}>
                <img src={`${Object.keys(allData).length > 0 ? (allData.place.length > 0 ? allData.place[0].image : "") : ""}`} onError={HandleError} alt="meeting room" className="object-cover w-full h-40" />
            </div>
            <div className={`${Type ? "w-full" : "xl:w-3/4 sm:w-8/12 w-full sm:mt-0 mt-5"}`}>
                <div className="w-full flex flex-wrap">
                    <div className="xl:w-1/2 w-full">
                        <TitleSection Text={`Event Name`} Type="x-large" />
                        <p className="text-left sm:mt-1 mt-0 sm:mb-4 mb-2">{`${Object.keys(allData).length > 0 ? allData.contact.eventName : ""}`}</p>
                        {/* <p className="text-left mt-1 mb-4 hidden">{`${Object.keys(allData).length > 0 ? allData.address : ""}`}, {`${Object.keys(allData).length > 0 ? allData.countryName : ""}`} {`${Object.keys(allData).length > 0 && allData.phone !== "" ? "Telephone "+allData.phone : ""}`}</p> */}
                        {/* <TitleSection Text={`${Object.keys(allData).length > 0 ? allData.contact.eventName : ""}`} Type="x-large" /> */}
                    </div>
                    <div className="xl:w-1/2 w-full flex items-start">
                        <p className="mt-2 sm:mr-5 mr-2">Your RFP ID : </p>
                        <h3 className="xl:text-base text-sm border-4 border-dotted border-gray-400 xl:py-2 py-1 bg-gray-100 mb-3 md:px-5 px-2 font-bold">{`${Object.keys(allData).length > 0 ? allData.rfpCode : ""}`}</h3>
                    </div>
                </div>
                <div className="w-full flex flex-wrap items-center mt-1">
                    <div className={`${Type ? "xl:w-1/2" : "xl:w-2/6"} w-full text-left`}>
                        <div className="w-full flex items-start">
                            <FaDoorOpen className="inline mr-2 mt-1" />
                            <p>Event type : <span className="inline-block text-sm">{`${Object.keys(allData).length > 0 ? allData.events.eventTypeName : ""}`}</span></p>
                        </div>
                        <div className="w-full flex items-start">
                            <FaDoorOpen className="inline mr-2 mt-1" />
                            <p>Attendees : <span className="inline-block text-sm">{`${Object.keys(allData).length > 0 ? allData.events.totalAttendees : ""}`}</span></p>
                        </div>
                    </div>
                    <div className={`xl:w-2/6 w-full text-left ${Type ? "hidden" : ""}`}>
                        <div className="xl:w-full w-auto xl:flex-none flex xl:justify-start xl:mt-0 mt-3 pr-5">
                            {/* {Object.keys(allData).length > 0 ? (
                                <>
                                    <p className="text-left">Status :<br />
                                        <span style={{ color: allData.approvedCount > 0 ? "green" : (
                                            allData.downCount > 0 ? "red" : (
                                                allData.waitingCountnya > 0 ? "blue" : "#4994ce"
                                            )
                                        ) }}>{allData.rawRfpStatus !== "" ? allData.rawRfpStatus : allData.rfpStatus}</span>
                                    </p>
                                </>
                            ) : ("")} */}
                            {!Type ? (
                            <p className="text-left">Status :<br />
                                {(() => {
                                    if (allData.completedCount > 0) {
                                        return <span className='font-bold text-sm' style={{ color: "#22C516" }}>{allData.rawRfpStatus}</span>
                                    }

                                    if (allData.approvedCount > 0) {
                                        return <span className='font-bold text-sm' style={{ color: "#22C516" }}>{allData.rawRfpStatus}</span>
                                    }

                                    if (allData.approvalCount > 0) {
                                        return <span className='font-bold text-sm' style={{ color: "#2A8CD8" }}>{allData.rawRfpStatus}</span>
                                    }

                                    if (allData.waitingCount > 0) {
                                        return <span className='font-bold text-sm' style={{ color: "#2A8CD8" }}>{allData.rawRfpStatus}</span>
                                    }

                                    if (allData.downCount > 0) {
                                        return <span className='font-bold text-sm' style={{ color: "#EA4545" }}>{allData.rawRfpStatus}</span>
                                    }

                                    if (allData.approvedCount === 0 && allData.approvalCount === 0 && allData.waitingCount === 0 && allData.downCount === 0) {
                                        return <span className='font-bold text-sm' style={{ color: "#2A8CD8" }}>{allData.rawRfpStatus}</span>
                                    }
                                })()}
                            </p>
                            ) : ("")}
                        </div>
                    </div>
                    <div className={`${Type ? "xl:w-1/2" : "xl:w-2/6"} w-full text-right xl:mt-0 mt-5 xl:flex-none flex flex-wrap items-end xl:justify-end`}>
                        {Type ? (
                            <>
                            <div className="xl:w-9/12 pr-2">
                                {/* <div className="flex flex-wrap w-full">
                                    <p className="text-xs text-right">Invoice Number : </p>
                                    <p className="text-xs text-right font-bold mb-2">{Object.keys(allData).length > 0 ? allData.invoiceNumber : ""}</p>
                                </div> */}
                                <div className={`flex flex-wrap w-full ${Type ? "justify-end" : ""}`}>
                                    <p className="text-xs text-right">Date : <span className="font-bold">{Object.keys(allData).length > 0 ? <DateFormat2 dateTime={`${allData.createdAt}`} /> : ""}</span></p>
                                </div>
                            </div>
                            <div className="xl:w-3/12 xl:block hidden">
                                
                            </div>
                            </>
                        ) : (
                            <>
                                <p className="xl:w-full w-auto text-xs">{Object.keys(allData).length > 0 ? <DateFormat dateTime={`${allData.events.startDate}`} /> : ""} - <DateFormat status={1} dateTime={`${allData.events.endDate}`} /></p>
                                <Link to={`/my-history-rfp-detail/${Object.keys(allData).length > 0 ? allData.rfpCode : ""}`} className="px-6 rounded-md text-sm text-white py-1 uppercase xl:ml-0 ml-4" style={{ backgroundColor: "#fed500" }}>View Details</Link>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}
ThumbnailHistory.defaultProps = {
    Type: "",
    allData: ""
}
